import { useQuery } from "@connectrpc/connect-query";
import { Link, createFileRoute } from "@tanstack/react-router";

import { OperatorService } from "@yatayat/gen/yatayat/operator/v1/operator_pb";

import { useStaffSessionExpiry } from "~/components/OperatorTrip";
import { ScheduleForm } from "~/components/ScheduleForm";
import { useI18n } from "~/lib/i18n";
import { retryTransient } from "~/lib/rpc/errors";
import { ui } from "~/lib/ui";

export const Route = createFileRoute("/operator/schedules/$scheduleId")({
  component: EditSchedule,
});

function EditSchedule() {
  const { scheduleId } = Route.useParams();
  const { t } = useI18n();
  const schedules = useQuery(OperatorService.method.listSchedules, {}, { retry: retryTransient });
  const unauthenticated = useStaffSessionExpiry(schedules.error);
  const schedule = schedules.data?.schedules.find((s) => s.id === scheduleId);

  let body;
  if (schedule) {
    // A different schedule starts the form afresh.
    body = <ScheduleForm key={schedule.id} schedule={schedule} />;
  } else if (schedules.isPending || unauthenticated) {
    body = <p className="text-slate-600 dark:text-slate-400">{t("loading")}</p>;
  } else if (schedules.data) {
    body = <p className="text-slate-600 dark:text-slate-400">{t("scheduleNotFoundPage")}</p>;
  } else {
    body = <p className="text-brand dark:text-brand-dark">{t("somethingWrong")}</p>;
  }

  return (
    <div className="mx-auto max-w-xl space-y-4">
      <Link to="/operator/schedules" className="text-sm text-ink underline-offset-2 hover:underline dark:text-ink-dark">
        <span aria-hidden="true">← </span>
        {t("allSchedules")}
      </Link>
      <h1 className={ui.h1}>{t("editSchedule")}</h1>
      {body}
    </div>
  );
}
